// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"ff511239","514":"e7584992"}[chunkId] + ".chunk.css";
};